import { render } from "./ProfileAgenda.view.vue?vue&type=template&id=b823a88a"
import script from "./ProfileAgenda.view.vue?vue&type=script&lang=js"
export * from "./ProfileAgenda.view.vue?vue&type=script&lang=js"

import "./ProfileAgenda.view.vue?vue&type=style&index=0&id=b823a88a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__